/* globals $ sessionStorage */

export const CART_CHANGED = 'rcmShopifyApi:cartChanged'

export const TERMS_CHECKBOX = 'cartCheckbox:agreeTerms'
export const POLICIES_CHECKBOX = 'cartCheckbox:agreePolicies'

class RCMShopifyAPI {
  constructor () {
    this._events = []
  }

  addProduct (serializedData) {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: serializedData
      }).done((productData) => {
        this.getCart().then((cartData) => {
          const returnData = {
            productData,
            cartData
          }

          this._resolveEvents(CART_CHANGED, returnData)
          resolve(returnData)
        }).catch((textStatus) => {
          reject(textStatus)
        })
      }).fail((jqXHR, textStatus, errorThrown) => {
        reject(textStatus)
      })
    })
  }

  getCart () {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json'
      }).done((cartData) => {
        resolve(cartData)
      }).fail((jqXHR, textStatus, errorThrown) => {
        reject(textStatus)
      })
    })
  }

  getCartCheckbox (checkboxType) {
    if (sessionStorage) {
      if (sessionStorage.getItem(checkboxType) === 'true') {
        return true
      }
    }

    return false
  }

  setCartCheckbox (checkboxType) {
    if (sessionStorage) {
      sessionStorage.setItem(checkboxType, 'true')
    }
  }

  removeCartCheckbox (checkboxType) {
    if (sessionStorage) {
      sessionStorage.removeItem(checkboxType)
    }
  }

  clearCartCheckboxes () {
    if (sessionStorage) {
      sessionStorage.removeItem(TERMS_CHECKBOX)
      sessionStorage.removeItem(POLICIES_CHECKBOX)
    }
  }

  // ***********
  // Utility functions
  // ***********

  on (eventString, callback) {
    if (typeof callback !== 'function') {
      return
    }

    if (typeof this._events[eventString] === 'undefined') {
      this._events[eventString] = []
    }
    this._events[eventString].push(callback)
  }

  off (eventString, callback) {
    if (typeof this._events[eventString] === 'undefined') {
      return
    }

    let newArray = []
    for (let i = 0, len = this._events[eventString].length; i < len; i++) {
      if (callback !== this._events[eventString][i]) {
        newArray.push(this._events[eventString][i])
      }
    }
    this._events[eventString] = newArray
  }

  // ***********
  // Internal functions
  // ***********

  _resolveEvents (eventString, data) {
    if (typeof this._events[eventString] === 'undefined') {
      return
    }

    for (let i = 0, len = this._events[eventString].length; i < len; i++) {
      this._events[eventString][i](data, this)
    }
  }
}

export const rcmShopifyApi = new RCMShopifyAPI()
